module.exports = __webpack_public_path__ + "static/media/right.59b98e14.svg";